import { createFileRoute } from '@tanstack/react-router'
import AudioDetailPage from '@/pages/resources/audio/detail'

export const Route = createFileRoute('/app/resources/audio/$id')({
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  return <AudioDetailPage id={Number(id)} />
}
